<template>
  <div class="goldenLV"  v-on:scroll="handleScroll(event)" style="  overflow: hidden;">
      <div id="label"><h1 id="labeltext">金石<br>成大砌</h1><hr id="labelhr"></div>
      <div class="content">  
          <img src="./../assets/big/big.jpg" id="goldenlv">                              
        <div id="description">
          <h2>35年資深品牌，榮獲第21屆國家建築金質獎及國家優良建商第一品牌，秉持『深耕在地，用心經營，誠信踏實』的企業理念，在大嘉義地區選擇最好的地段蓋最好的房子。</h2>
        </div>
        <div class="buildings" :id="this.buildingdescription1">
              <table>
                <tr>
                  <td class="descri_title">建案規劃</td>
                  <td class="descri_content">透天電梯店住</td>
                </tr>
                <tr>
                  <td class="descri_title">所在區域</td>
                  <td class="descri_content">嘉義市</td>
                </tr>
                <tr>
                  <td class="descri_title">諮詢專線</td>
                  <td class="descri_content">05-2316999</td>
                </tr>                
                <tr>
                  <td class="descri_title">基地位址</td>
                  <td class="descri_content">嘉義市西區博愛路與大統路口</td>
                </tr>                
                <tr>
                  <td class="descri_title">接待中心</td>
                  <td class="descri_content">嘉義市西區世賢路二段299號</td>
                </tr>
              </table>       
        </div>
        <div class="buildings" :id="this.buildingdescription2">
            <table>
              <tr>
                <td class="descri_title">地坪</td>
                <td class="descri_content">30.3~35.9坪</td>
              </tr>
              <tr>
                <td class="descri_title">建坪</td>
                <td class="descri_content">住69.85~78.28坪，店72.75～92.9坪</td>
              </tr>
              <tr>
                <td class="descri_title">面寬</td>
                <td class="descri_content">4.6米~5米</td>
              </tr>                
              <tr>
                <td class="descri_title">座向</td>
                <td class="descri_content">座東南朝西北,座西北朝東南,座東北朝西南</td>
              </tr>                
              <tr>
                <td class="descri_title">總戶數</td>
                <td class="descri_content">住46戶，店26戶</td>
              </tr>
            </table>
        </div>
        <div class="buildings" :id="this.buildingdescription3">
            <table>
              <tr>
                <td class="descri_title">基地面積</td>
                <td class="descri_content">約2,600坪</td>
              </tr>
              <tr>
                <td class="descri_title">房間規劃</td>
                <td class="descri_content">4~5房</td>
              </tr>
              <tr>
                <td class="descri_title">樓層規劃</td>
                <td class="descri_content">地上5層</td>
              </tr>                
              <tr>
                <td class="descri_title">透天車位</td>
                <td class="descri_content">1~2</td>
              </tr>                
              <tr>
                <td class="descri_title">交通環境</td>
                <td class="descri_content">西區博愛路與大統路口</td>
              </tr>
            </table>
        </div>
        <div class="buildings" :id="this.buildingdescription4">
            <table>
              <tr>
                <td class="descri_title">公園綠地</td>
                <td class="descri_content">港坪運動公園、興嘉公園、美術館、文創園區</td>
              </tr>
              <tr>
                <td class="descri_title">鄰近國小</td>
                <td class="descri_content" style="width: 360px;">港坪國小</td>
              </tr>
              <tr>
                <td class="descri_title">鄰近國中</td>
                <td class="descri_content" style="width: 360px;">玉山國中</td>
              </tr>                
              <tr>
                <td class="descri_title">鄰近大學</td>
                <td class="descri_content">嘉義大學新民校區</td>
              </tr>                
              <tr>
                <td class="descri_title">查看地圖</td>
                <td class="descri_content">未提供</td>
              </tr>
            </table>      
        </div>
        <div class="buildings" :id="this.buildingdescription5">
        <table><tr>
            <td class="descri_title">購物環境</td>
            <td class="shop_content">7-11、家樂福、大潤發、全聯福利中心、玉山商圈</td>
        </tr></table>        
        </div>

      </div>
      <div class="photo_container">
        <img src="./../assets/big/big2.jpg" 
            class="photo" :id="this.photoshow1">
        <img src="./../assets/big/big3.jpg" 
            class="photo" :id="this.photoshow1">
        <img src="./../assets/big/big4.jpg" 
            class="photo" :id="this.photoshow1">
        <img src="./../assets/big/big5.png" 
            class="photo" :id="this.photoshow1">
      </div>
  </div>
  
</template>
 
<script>
import navlist from '../components/navlist.vue'
export default {
  components:{
    navlist
  },
  data(){
    return {     
      buildingdescription1:"", 
      buildingdescription2:"", 
      buildingdescription3:"", 
      buildingdescription4:"", 
      buildingdescription5:"", 
      photoshow1:"",
      photoshow2:"",
      photoshow3:"",
      photoshow4:""
      }
  },
  methods: {
      handleScroll (event) {
        this.windowscrollY = window.scrollY
        // console.log(this.windowscrollY)
        if (this.windowscrollY > 33) {
            this.buildingdescription1 = 'buildingdescription1'
        }        
        if (this.windowscrollY > 180) {
            this.buildingdescription2 = 'buildingdescription2'
        }        
        if (this.windowscrollY > 380) {
            this.buildingdescription3 = 'buildingdescription3'
        }        
        if (this.windowscrollY > 580) {
            this.buildingdescription4 = 'buildingdescription4'
        }        
        if (this.windowscrollY > 760) {
            this.buildingdescription5 = 'buildingdescription5'
        }        
        if (this.windowscrollY > 1002) {
            this.photoshow1 = 'photoshow1'
        }        
        if (this.windowscrollY > 1230) {
            this.photoshow2 = 'photoshow2'
        }        
        if (this.windowscrollY > 1500) {
            this.photoshow3 = 'photoshow3'
        }
        if (this.windowscrollY > 1740) {
            this.photoshow4 = 'photoshow4'
        }
      // else console.log('no')
      }
  },
  created () {
      window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style scoped>
.goldenLV{
  width: 100%;
  height: auto;
  margin: 80px 0 0 0;
}
#label {
  margin: 0 0;
  width:  100%;
  height: 60px;
}
@keyframes show-draw{
    100% {
        opacity: 1;
        }
    }
#labeltext {
  margin: auto 0 auto 6%;
  float: left;
  width:  24%;
  height: 20px;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.71px;
  color: #a89a80;
  opacity: 0;
  animation: show-draw 0.6s linear forwards;
  -webkit-animation: show-draw 0.6s linear forwards;
  animation-delay: 0.8s;
	-webkit-animation-delay: 0.8s;
}
@keyframes show-draw-hr{
    100% {
        /* width: 82%; */
        transform-origin: left top;
        width: 68%;
        }
    }
#labelhr {
  margin: 15px 0;
  float: right;
  width: 2%;
  border: solid 0.5px #d0ad76;
  animation: show-draw-hr 0.9s ease-out forwards;
  -webkit-animation: show-draw-hr 0.9s ease-out forwards;
  animation-delay: 0s;
	-webkit-animation-delay: 0s;
}

@keyframes showtext{
    100% {
      opacity: 1;
      transform: translateY(4px);
        }
    }

.content{
  width: 100%;
  height: auto;
  text-align: center;
}

#goldenlv{
  margin: 3% auto;
  width: 88%;
  opacity: 0;
  animation: showtext 0.9s ease-in-out forwards;
  -webkit-animation: showtext 0.9s ease-in-out forwards;
  animation-delay: 0.8s;
	-webkit-animation-delay: 0.8s;
}

#description h2 {
  margin: 3% auto;
  width: 84%;
  height: auto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.14;
  letter-spacing: 1.11px;
  text-align: justify;
  color: #7d7d7d;
  opacity: 0;
  animation: showtext 0.9s ease-in-out forwards;
  -webkit-animation: showtext 0.9s ease-in-out forwards;
  animation-delay: 1.2s;
	-webkit-animation-delay: 1.2s;
}

.buildings{
  margin: 7% auto 7% 8.5%;
  width: 87%;
  border-left: solid 0.7px #a89a80;
  padding: 1px 10px;
  opacity: 0;
}

#buildingdescription1, #buildingdescription2, #buildingdescription3, #buildingdescription4, #buildingdescription5{
  animation: showtext 0.6s ease-in-out forwards;
  -webkit-animation: showtext 0.6s ease-in-out forwards;
  animation-delay: 0.2s; 
  -webkit-animation-delay: 0.2s; 
}

.descri_title {
  width: 85px;
  height: auto;
  margin-right: 0;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.31;
  letter-spacing: 1.03px;
  text-align: justify;
  color: #a89a80;
}

.descri_content  {
  width: 210px;
  height: auto;
  margin-left:0;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.31;
  letter-spacing: 1.03px;
  text-align: justify;
  color: #7d7d7d;
  overflow: visible;
}

.photo_container{
  width: 100%;
  height: auto;
  margin: 8% auto 0 auto;
  padding:5% 0;
  text-align: center;
  background-image: linear-gradient(to top, #c4c3c231 31%, #dadad962 40%, #feffff 100%);
}

.photo{
  margin: 3% auto;
  width: 88%;
  opacity: 0;
}

#photoshow1,#photoshow2,#photoshow3,#photoshow4{   
  animation: showtext 0.9s ease-in forwards;
  -webkit-animation: showtext 0.9s ease-in forwards;
  animation-delay: 0.3s; 
  -webkit-animation-delay: 0.3s; 
  }
</style>